/**
 * @generated SignedSource<<4c2bf0d0fcce689bfe74cda4ac04fc8c>>
 * @relayHash ec86b94bacd89c4d545c608256e2ce31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d385ee8659c1c15ce72a6945d4db5f703bb500913381ae8718823896ba7da93

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StakeholderGroupsPageQuery$variables = {
  after?: string | null | undefined;
  first: number;
};
export type StakeholderGroupsPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StakeholderGroupPageContent">;
};
export type StakeholderGroupsPageQuery = {
  response: StakeholderGroupsPageQuery$data;
  variables: StakeholderGroupsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StakeholderGroupsPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "StakeholderGroupPageContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StakeholderGroupsPageQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "StakeholderCommsStakeholderGroupAndStakeholdersConnection",
        "kind": "LinkedField",
        "name": "stakeholderComms_getStakeholderGroupsWithStakeholders",
        "plural": false,
        "selections": [
          {
            "concreteType": "StakeholderCommsStakeholderGroupAndStakeholdersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "StakeholderCommsStakeholderGroupsAndStakeholders",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "StakeholderCommsStakeholderGroup",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "services"
                      },
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      }
                    ]
                  },
                  {
                    "concreteType": "StakeholderCommsStakeholder",
                    "kind": "LinkedField",
                    "name": "stakeholders",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "avatar"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "aaid"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "concreteType": "StakeholderCommsNotificationPreference",
                        "kind": "LinkedField",
                        "name": "notificationPreference",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "emailId"
                          },
                          (v3/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ownerName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ownerAvatar"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "error"
          },
          {
            "concreteType": "StakeholderCommsPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "handle": "connection",
        "key": "StakeholderGroupTableLayout_stakeholderComms_getStakeholderGroupsWithStakeholders",
        "kind": "LinkedHandle",
        "name": "stakeholderComms_getStakeholderGroupsWithStakeholders"
      }
    ]
  },
  "params": {
    "id": "0d385ee8659c1c15ce72a6945d4db5f703bb500913381ae8718823896ba7da93",
    "metadata": {},
    "name": "StakeholderGroupsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ce93b94ed54a7afc00ff594c131c3334";

export default node;
